// extracted by mini-css-extract-plugin
export default {"GateBody":"imageConvolution_GateBody__GJu2y","Row":"imageConvolution_Row__JqSRJ"};